var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product__item-grid"},_vm._l((_vm.sslPlans),function(sslPlan){return _c('ssl-plan',{key:sslPlan.name,attrs:{"productPlan":sslPlan,"domain":_vm.domain}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }